import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Text from "@amzn/meridian/esm/components/text";
import errorTokens from "@amzn/meridian-tokens/base/icon/error";
import WaveformLayout from "../../components/waveformLayout/WaveformLayout";
import { scaleIconClass } from "../../styles/icon.styles";
import { WAVEFORM_ICON_SCALE } from "../../constants";

// Someone else is already starting the session: same layout as HIRE's rejected screen.
const RtmsRejected = ({ rtmsRequesterName, message }) => (
  <WaveformLayout icon={<Icon className={scaleIconClass(WAVEFORM_ICON_SCALE)} tokens={errorTokens} color="error" />}>
    <Column spacing="none">
      <Text type="h50">{rtmsRequesterName}</Text>
      <Text type="b200">{message}</Text>
    </Column>
  </WaveformLayout>
);

export default RtmsRejected;
